import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/select";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from "@/components/ui/tooltip";
import { HelpCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

interface LanguageLevelFieldsProps {
  profile: any;
  setProfile: (profile: any) => void;
  readOnly: boolean;
  loading: boolean;
}

export function LanguageLevelFields({
  profile,
  setProfile,
  readOnly,
  loading
}: LanguageLevelFieldsProps) {
  const { t } = useTranslation(["talent", "common"]);

  return (
    <>
      <div className="space-y-1">
        <div className="flex items-center gap-1">
          <label className="text-sm font-medium">
            {t("common:german_skills")}
          </label>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger>
                <HelpCircle className="h-4 w-4 text-gray-400" />
              </TooltipTrigger>
              <TooltipContent>
                <p>
                  {t(
                    "forms.sections.language_skills.fields.german_language_skills.help"
                  )}
                </p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        <Select
          disabled={readOnly}
          value={profile?.german_language_skills}
          onValueChange={(value) =>
            setProfile({ ...profile!, german_language_skills: value })
          }
        >
          <SelectTrigger id="german-level-trigger" loading={loading}>
            <SelectValue
              placeholder={t(
                "forms.sections.language_skills.fields.german_language_skills.placeholder"
              )}
            />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="a1">
              {t("forms.sections.language_skills.levels.a1")}
            </SelectItem>
            <SelectItem value="a2">
              {t("forms.sections.language_skills.levels.a2")}
            </SelectItem>
            <SelectItem value="b1">
              {t("forms.sections.language_skills.levels.b1")}
            </SelectItem>
            <SelectItem value="b2">
              {t("forms.sections.language_skills.levels.b2")}
            </SelectItem>
            <SelectItem value="c1">
              {t("forms.sections.language_skills.levels.c1")}
            </SelectItem>
            <SelectItem value="c2">
              {t("forms.sections.language_skills.levels.c2")}
            </SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-1">
        <div className="flex items-center gap-1">
          <label className="text-sm font-medium">
            {t("forms.sections.language_skills.fields.language_school.label")}
          </label>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger>
                <HelpCircle className="h-4 w-4 text-gray-400" />
              </TooltipTrigger>
              <TooltipContent>
                <p>
                  {t(
                    "forms.sections.language_skills.fields.language_school.help"
                  )}
                </p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        <Select
          disabled={readOnly}
          value={profile?.language_school}
          onValueChange={(value) =>
            setProfile({ ...profile!, language_school: value })
          }
        >
          <SelectTrigger loading={loading}>
            <SelectValue
              placeholder={t(
                "forms.sections.language_skills.fields.language_school.placeholder"
              )}
            />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="afu">
              {t("forms.sections.language_skills.schools.afu")}
            </SelectItem>
            <SelectItem value="goethe">
              {t("forms.sections.language_skills.schools.goethe")}
            </SelectItem>
            <SelectItem value="osd">
              {t("forms.sections.language_skills.schools.osd")}
            </SelectItem>
            <SelectItem value="telc">
              {t("forms.sections.language_skills.schools.telc")}
            </SelectItem>
            <SelectItem value="testdaf">
              {t("forms.sections.language_skills.schools.testdaf")}
            </SelectItem>
            <SelectItem value="other">
              {t("forms.sections.language_skills.schools.other")}
            </SelectItem>
          </SelectContent>
        </Select>
      </div>
    </>
  );
}
